import { renderToString } from 'react-dom/server';
import { getServerState } from 'react-instantsearch-hooks-server';

import { DynamicComponents, ListOfFlats } from '@/templates';

import { config } from '@/config';
import { getMinBookingDays, getPage } from '@/graphql/queries';
import { dynamicComponentsTransformer } from '@/graphql/transformers';
import { routes } from '@/lib';

import type { TypeTheme } from '@/types';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import type { InstantSearchServerState } from 'react-instantsearch-hooks-web';

type FlatCategoryProps = {
  page: {
    theme: TypeTheme;
    langcode: {
      id: 'es';
    };
    // TODO: tipar
    attributes: any;
    menu: any[];
    preFooter: any[];
    minBookingDays: number;
  };
  serverState: InstantSearchServerState;
};

const FlatCategory = ({
  serverState,
  page: {
    minBookingDays,
    attributes: { Content: dynamicContent },
  },
}: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <>
    <ListOfFlats
      defaultArea="todas las zonas"
      typeText="de alquiler temporal"
      serverState={serverState}
      type="MED_EST"
      minBookingDays={minBookingDays}
    />

    {dynamicContent.map(({ __typename, ...props }: any, index: number) => (
      <DynamicComponents
        type={__typename}
        {...props}
        key={`${__typename}-${index}`}
      />
    ))}
  </>
);

export const getServerSideProps: GetServerSideProps<
  FlatCategoryProps
> = async () => {
  const minBookingDays = (await getMinBookingDays()) ?? config.minBookingDays;
  const { pages, menusMenus, preFooter } = await getPage(
    routes.flats.half.index
  );
  const attributes = pages.data[0]?.attributes || {};
  attributes.Content = attributes?.Content
    ? dynamicComponentsTransformer(attributes.Content)
    : [];

  const serverState = await getServerState(
    <ListOfFlats
      defaultArea="todas las zonas"
      typeText="de alquiler temporal"
      type="MED_EST"
      minBookingDays={minBookingDays}
    />,
    {
      renderToString,
    }
  );

  return {
    props: {
      serverState,
      page: {
        theme: 'light' as TypeTheme,
        langcode: {
          id: 'es',
        },
        attributes,
        minBookingDays,
        menu: menusMenus?.data || [],
        preFooter: preFooter?.data || [],
      },
    },
  };
};

export default FlatCategory;
